import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Testimonials = (): React.JSX.Element => {
    return (
        <div data-testid="testimonialsContent">
            <Container className="py-5">
                <Row>
                    <Col>
                        <p>
                            We would love to hear about your experience with the
                            MAJOR Youth Baseball League and the MAJOR High
                            School League. Please take a moment and let us know
                            why you love the MAJOR YBL. We will share your
                            experiences with others, so they can see why we have
                            become Wisconsin's Youth Baseball League.
                            <Link to="mailto:shawn@majorybl.com">
                                Please send us your testimonials
                            </Link>
                        </p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Testimonials;
